import React, { useEffect, useRef } from 'react'
import { Animated, Platform, Text, View } from 'react-native'

/** Shared visual only: neither app needs the other's theme provider. */
export function NewMessageDivider({ dismissed, color = '#a01818' }: { dismissed: boolean; color?: string }) {
  const opacity = useRef(new Animated.Value(1)).current
  useEffect(() => {
    if (!dismissed) return
    Animated.timing(opacity, { toValue: 0, duration: 400, useNativeDriver: Platform.OS !== 'web' }).start()
  }, [dismissed, opacity])
  return <Animated.View accessibilityLabel="New messages" style={{ flexDirection: 'row', alignItems: 'center', gap: 8,
    marginVertical: 12, paddingHorizontal: 4, opacity }}>
    <View style={{ flex: 1, height: 1, backgroundColor: color }} />
    <Text style={{ fontSize: 10, fontWeight: '700', letterSpacing: 2, color }}>NEW</Text>
  </Animated.View>
}
